(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[441],{

/***/ 4664:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/add",
      function () {
        return __webpack_require__(1240);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4914);
/* harmony import */ var _styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Radio = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var title = param.title, view = param.view, radios = param.radios, selected = param.selected, visibility = param.visibility, style = param.style, onChange = param.onChange;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selected), rd = _$ref[0], setRd = _$ref[1];
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return setRd(selected);
    }, [
        selected
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return rd;
            },
            set: function set(v) {
                if (!radios.filter(function(r) {
                    return r.value.toString() === v.toString();
                }).length) return;
                setRd(v.toString());
            }
        };
    });
    /** TEMPLATE */ if (!radios.length || !selected.toString().length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rd),
            view !== "box" && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[view]
        ].filter(Boolean).join(" "),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdContent),
                    (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inline)
                ].join(" "),
                children: radios.map(function(value, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: [
                            (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdRadio),
                            rd === value.value && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                            value.disabled && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            if (rd !== value.value) {
                                setRd(value.value);
                                if (onChange) onChange(value.value);
                            }
                        },
                        disabled: value.disabled,
                        children: value.text
                    }, index);
                })
            })
        ]
    });
});
Radio.displayName = "Radio";
Radio.defaultProps = {
    radios: [],
    selected: "",
    visibility: true,
    view: "box"
};
/* harmony default export */ __webpack_exports__["Z"] = (Radio);


/***/ }),

/***/ 3639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1319);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Textarea = function(param) {
    var title = param.title, value = param.value, placeholder = param.placeholder, isWrappedStyle = param.isWrappedStyle, isError = param.isError, autoHeight = param.autoHeight, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), txt = ref[0], setTxt = ref[1];
    var parentId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var textareaId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var handleOnClick = function() {
        if (textareaId.current) textareaId.current.focus();
    };
    var handleOnChange = function(e) {
        if (textareaId.current && autoHeight) {
            textareaId.current.style.height = "auto";
            textareaId.current.style.height = textareaId.current.scrollHeight + "px";
        }
        if (onChange) onChange(e.target.value);
        setTxt(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txt),
            isWrappedStyle && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().full),
            isError && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error)
        ].filter(Boolean).join(" "),
        onClick: handleOnClick,
        ref: parentId,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtContent),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    onInput: handleOnChange,
                    ref: textareaId,
                    placeholder: placeholder,
                    children: txt
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 1240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ add; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/Header.js + 4 modules
var Header = __webpack_require__(798);
// EXTERNAL MODULE: ./components/Radio.js
var Radio = __webpack_require__(8801);
// EXTERNAL MODULE: ./components/Input.js
var Input = __webpack_require__(1121);
// EXTERNAL MODULE: ./components/Select.js
var Select = __webpack_require__(360);
// EXTERNAL MODULE: ./components/Textarea.js
var Textarea = __webpack_require__(3639);
// EXTERNAL MODULE: ./node_modules/react-dropzone-uploader/dist/react-dropzone-uploader.js
var react_dropzone_uploader = __webpack_require__(5990);
var react_dropzone_uploader_default = /*#__PURE__*/__webpack_require__.n(react_dropzone_uploader);
;// CONCATENATED MODULE: ./components/MyDropzone.js



var MyDropzone = function(param) {
    var images = param.images;
    // specify upload params and url for your files
    var getUploadParams = function(param) {
        var meta = param.meta;
        return {
            url: "https://baza.estate/api/v2" + "/_object/images"
        };
    };
    // called every time a file's `status` changes
    var handleChangeStatus = function(param, status) {
        var meta = param.meta, remove = param.remove, file = param.file, xhr = param.xhr;
        if (xhr) {
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    var result = JSON.parse(xhr.response);
                    console.log(result);
                    if ((result === null || result === void 0 ? void 0 : result.status) == "ok") images.push(result.data.path);
                }
            };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "toast"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_dropzone_uploader_default()), {
                getUploadParams: getUploadParams,
                onChangeStatus: handleChangeStatus,
                accept: "image/*",
                inputContent: function(files, extra) {
                    return extra.reject ? "Только фотографии" : "Выберите фото для загрузки";
                },
                inputWithFilesContent: "Добавить фото",
                submitButtonContent: "OK",
                styles: {
                    dropzoneReject: {
                        borderColor: "red",
                        backgroundColor: "#DAA"
                    },
                    inputLabelWithFiles: {
                        marginBottom: 10
                    },
                    inputLabel: function(files, extra) {
                        return extra.reject ? {
                            color: "black"
                        } : {};
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var components_MyDropzone = (MyDropzone);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(8548);
// EXTERNAL MODULE: ./styles/modules/add/Add.module.scss
var Add_module = __webpack_require__(8803);
var Add_module_default = /*#__PURE__*/__webpack_require__.n(Add_module);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./node_modules/react-yandex-maps/dist/production/react-yandex-maps.esm.js
var react_yandex_maps_esm = __webpack_require__(8112);
;// CONCATENATED MODULE: ./pages/[region]/add.js

















//import Added from '../../public/images/added.svg';


//const TemplateProvider = withYMaps(({ children, template }) => children({ template }), true, ['templateLayoutFactory']);
var AddPage = function() {
    var ref;
    var locationState = (0,context_location/* useLocationState */.KJ)();
    var mapEl = (0,react.useRef)();
    var addressId = (0,react.useRef)();
    var priceId = (0,react.useRef)();
    var squareId = (0,react.useRef)();
    var contactPhoneId = (0,react.useRef)();
    var contactsNameId = (0,react.useRef)();
    var codeId = (0,react.useRef)();
    //const ymaps = useYMaps(["Map", "SuggestView"]);
    var loadSuggest = function(ymaps) {
        var suggestView = new ymaps.SuggestView("suggest");
        suggestView.events.add("select", function(e) {
            //console.log(e.get("item").value);
            ymaps.geocode(e.get("item").value).then(function(result) {
                var rawPoints = [];
                // console.log(result.geoObjects.get(0).properties.get('metaDataProperty'))
                // console.log(result.geoObjects.get(0).getThoroughfare())
                // console.log(result.geoObjects.get(0).properties.get('metaDataProperty.GeocoderMetaData'))
                // console.log(result.geoObjects.get(0).properties.get('metaDataProperty.GeocoderMetaData').Address)
                //console.log(result.geoObjects.get(0).properties.get('boundedBy'))
                var coordinates = result.geoObjects.get(0).geometry.getCoordinates();
                rawPoints.push({
                    address: result.geoObjects.get(0).properties.get("metaDataProperty.GeocoderMetaData").Address.formatted,
                    Components: result.geoObjects.get(0).properties.get("metaDataProperty.GeocoderMetaData").Address.Components,
                    point: coordinates
                });
                setRawPoints(rawPoints);
                //console.log(rawPoints)
                try {
                    //if (mapEl.current)
                    mapEl.current.setCenter(coordinates);
                    mapEl.current.panTo(coordinates).then(function() {
                        mapEl.current.setZoom(17, {
                            duration: 300
                        });
                    });
                //setCenter(coordinates);
                } catch (error) {
                    console.log("some err");
                    console.log(error);
                }
            //console.log('map')
            //console.log(mapEl)
            //map.pointCommercial.geometry.setCoordinates(result.geoObjects.get(0).geometry.getCoordinates());
            //console.log('ok')
            // setValues({...values, coo})
            });
        });
    };
    var initialState = {
        type: "продажа",
        category: "квартира",
        rooms: "1",
        studio: 0,
        price: "",
        square: "",
        squareLiving: "",
        squareKitchen: "",
        squareArea: "",
        floor: "",
        floors: "",
        ceiling: "",
        stock: [],
        balcony: [],
        renovation: [],
        buildingType: [],
        bathroom: [],
        lotType: [],
        subCategory: [],
        entrance: [],
        commercialType: [],
        commercialBuildingType: [],
        images: [],
        contactName: "",
        contactPhone: "",
        description: ""
    };
    var ref1 = (0,react.useState)(false), showCode = ref1[0], setShowCode = ref1[1];
    var ref2 = (0,react.useState)(false), showInvite = ref2[0], setShowInvite = ref2[1];
    var ref3 = (0,react.useState)(true), addButton = ref3[0], setAddButton = ref3[1];
    var ref4 = (0,react.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,react.useState)(false), isAdded = ref5[0], setIsAdded = ref5[1];
    var ref6 = (0,react.useState)(initialState), objectsState = ref6[0], setObjectsState = ref6[1];
    var ref7 = (0,react.useState)(objectsState.type), type = ref7[0], setType = ref7[1];
    var ref8 = (0,react.useState)(objectsState.category), category = ref8[0], setCategory = ref8[1];
    var ref9 = (0,react.useState)(objectsState.commercialType), commercialType = ref9[0], setCommercialType = ref9[1];
    var ref10 = (0,react.useState)(objectsState.subCategory), subCategory = ref10[0], setSubCategory = ref10[1];
    var ref11 = (0,react.useState)(objectsState.commercialBuildingType), commercialBuildingType = ref11[0], setCommercialBuildingType = ref11[1];
    var ref12 = (0,react.useState)(objectsState.price), price = ref12[0], setPrice = ref12[1];
    var ref13 = (0,react.useState)(objectsState.studio), studio = ref13[0], setStudio = ref13[1];
    var ref14 = (0,react.useState)(objectsState.rooms), rooms = ref14[0], setRooms = ref14[1];
    var ref15 = (0,react.useState)(objectsState.square), square = ref15[0], setSquare = ref15[1];
    var ref16 = (0,react.useState)(objectsState.squareLiving), squareLiving = ref16[0], setSquareLiving = ref16[1];
    var ref17 = (0,react.useState)(objectsState.squareKitchen), squareKitchen = ref17[0], setSquareKitchen = ref17[1];
    var ref18 = (0,react.useState)(objectsState.squareArea), squareArea = ref18[0], setSquareArea = ref18[1];
    var ref19 = (0,react.useState)(objectsState.floor), floor = ref19[0], setFloor = ref19[1];
    var ref20 = (0,react.useState)(objectsState.floors), floors = ref20[0], setFloors = ref20[1];
    var ref21 = (0,react.useState)(objectsState.ceiling), ceiling = ref21[0], setCeiling = ref21[1];
    var ref22 = (0,react.useState)(objectsState.buildingType), buildingType = ref22[0], setBuildingType = ref22[1];
    var ref23 = (0,react.useState)(objectsState.renovation), renovation = ref23[0], setRenovation = ref23[1];
    var ref24 = (0,react.useState)(objectsState.stock), stock = ref24[0], setStock = ref24[1];
    var ref25 = (0,react.useState)(objectsState.description), description = ref25[0], setDescription = ref25[1];
    var ref26 = (0,react.useState)(objectsState.contactName), contactName = ref26[0], setContactName = ref26[1];
    var ref27 = (0,react.useState)(objectsState.contactPhone), contactPhone = ref27[0], setContactPhone = ref27[1];
    var ref28 = (0,react.useState)(objectsState.authCode), authCode = ref28[0], setAuthCode = ref28[1];
    var ref29 = (0,react.useState)(objectsState.lotType), lotType = ref29[0], setLotType = ref29[1];
    var ref30 = (0,react.useState)(objectsState.images), images = ref30[0], setImages = ref30[1];
    var ref31 = (0,react.useState)([]), rawPoints = ref31[0], setRawPoints = ref31[1];
    //const [geocoderData, setGeocoderData] = useState([]);
    (0,react.useEffect)(function() {
        var rawPoints = [];
    }, []);
    var checkCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(code) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(contactPhone.length === 11 && code.length === 4)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return axios_default().post("https://baza.estate/api/v2" + "/_tg/check", {
                            phone: contactPhone,
                            code: code
                        });
                    case 4:
                        response = _ctx.sent;
                        if (!(!response.data || response.data.status !== "ok")) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(response.data.text);
                    case 7:
                        if (response.data.data === "ok") {
                            setAddButton(false);
                        } else {
                            codeId.current.setError(true);
                        }
                        _ctx.next = 12;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                    case 12:
                        return _ctx.abrupt("return");
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function checkCode(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkContactPhone = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(phone) {
            var check, response, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        check = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                        if (!(phone.length === 11)) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return axios_default().post("https://baza.estate/api/v2" + "/_tg/check", {
                            phone: phone
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!(!response.data || response.data.status !== "ok")) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(response.data.text);
                    case 8:
                        if (response.data.data === "not_found") {
                            setShowInvite(true);
                            contactPhoneId.current.setError(true);
                        } else {
                            setShowCode("Код отправлен в телеграмм");
                            setAuthCode(false);
                            setShowInvite(false);
                        }
                        _ctx.next = 13;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](2);
                    case 13:
                        _ctx.next = 16;
                        break;
                    case 15:
                        {
                            setShowCode(false);
                            setShowInvite(false);
                        }
                    case 16:
                        return _ctx.abrupt("return");
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    11
                ]
            ]);
        }));
        return function checkContactPhone(phone) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var newObject, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!((rawPoints === null || rawPoints === void 0 ? void 0 : rawPoints.length) === 0 || (price === null || price === void 0 ? void 0 : price.length) <= 0 || (squareId === null || squareId === void 0 ? void 0 : squareId.length) <= 0 || (contactPhone === null || contactPhone === void 0 ? void 0 : contactPhone.length) < 6 || (contactName === null || contactName === void 0 ? void 0 : contactName.length) < 3)) {
                            _ctx.next = 7;
                            break;
                        }
                        addressId.current.setError((rawPoints === null || rawPoints === void 0 ? void 0 : rawPoints.length) === 0);
                        priceId.current.setError((price === null || price === void 0 ? void 0 : price.length) <= 0);
                        squareId.current.setError((squareId === null || squareId === void 0 ? void 0 : squareId.length) <= 0);
                        contactPhoneId.current.setError((contactPhone === null || contactPhone === void 0 ? void 0 : contactPhone.length) < 6);
                        contactsNameId.current.setError((contactName === null || contactName === void 0 ? void 0 : contactName.length) < 3);
                        return _ctx.abrupt("return");
                    case 7:
                        newObject = (0,_object_spread/* default */.Z)({}, objectsState);
                        newObject.type = type;
                        newObject.category = category;
                        newObject.price = price;
                        newObject.studio = [
                            "квартира"
                        ].includes(category) ? studio : 0;
                        newObject.rooms = [
                            "квартира"
                        ].includes(category) ? rooms : [];
                        newObject.square = square;
                        newObject.squareLiving = [
                            "квартира",
                            "комната",
                            "дом"
                        ].includes(category) ? squareLiving : "";
                        newObject.squareKitchen = [
                            "квартира",
                            "дом"
                        ].includes(category) ? squareKitchen : "";
                        newObject.squareArea = [
                            "дом",
                            "участок",
                            "коммерция"
                        ].includes(category) ? squareArea : "";
                        newObject.commercialType = [
                            "коммерция"
                        ].includes(category) ? commercialType : [];
                        newObject.commercialBuildingType = [
                            "коммерция"
                        ].includes(category) ? commercialBuildingType : [];
                        newObject.subCategory = [
                            "дом"
                        ].includes(category) ? subCategory : [];
                        newObject.floor = [
                            "квартира",
                            "комната",
                            "коммерция"
                        ].includes(category) ? floor : "";
                        newObject.floors = [
                            "квартира",
                            "комната",
                            "дом",
                            "коммерция"
                        ].includes(category) ? floors : "";
                        newObject.ceiling = [
                            "квартира",
                            "комната",
                            "дом",
                            "коммерция"
                        ].includes(category) ? ceiling : "";
                        newObject.description = description;
                        newObject.contactName = contactName;
                        newObject.contactPhone = contactPhone;
                        newObject.images = images;
                        newObject.rawPoints = rawPoints[0];
                        newObject.buildingType = [
                            "квартира",
                            "комната",
                            "дом"
                        ].includes(category) ? buildingType : [];
                        newObject.renovation = [
                            "квартира",
                            "комната",
                            "дом",
                            "коммерция"
                        ].includes(category) ? renovation : [];
                        newObject.stock = [
                            "квартира",
                            "комната"
                        ].includes(category) ? stock : [];
                        newObject.lotType = [
                            "дом",
                            "участок"
                        ].includes(category) ? lotType : [];
                        newObject.location = locationState.region;
                        newObject.authCode = authCode;
                        setObjectsState((0,_object_spread/* default */.Z)({}, newObject));
                        //console.log(newObject);
                        setIsLoading(true);
                        _ctx.next = 38;
                        return axios_default().post("https://baza.estate/api/v2" + "/object/add", {
                            obj: newObject
                        });
                    case 38:
                        response = _ctx.sent;
                        setIsLoading(false);
                        setIsAdded(true);
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                    case 42:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAddClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResetClick = function() {
        setIsAdded(!isAdded);
        setType(initialState.type);
        setCategory(initialState.category);
        setPrice("");
        setDescription("");
        setStudio(0);
        setRooms(initialState.rooms);
        setSquare("");
        setSquareLiving("");
        setSquareKitchen("");
        setSquareArea("");
        setCommercialType([]);
        setCeiling("");
        setFloor("");
        setFloors("");
        setRenovation([]);
        setBuildingType([]);
        setStock([]);
        setLotType([]);
        setSubCategory([]);
        setCommercialBuildingType([]);
        setImages([]);
        setRawPoints([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: [
                    "Продайте или сдайте недвижимость в ",
                    locationState.case,
                    " на baza.estate"
                ].join(""),
                description: [
                    "Используйте базу недвижимости, чтобы подать объявление о продаже или аренде недвижимости (квартиры, дома, комнаты, студии, коммерции, участка, бизнеса) в ",
                    locationState.case,
                    ". Разместить объявление бесплатно о продаже или аренде недвижимости."
                ].join(""),
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: [
                        "Продайте или сдайте недвижимость в ",
                        locationState.case,
                        " на baza.estate"
                    ].join(""),
                    description: [
                        "Используйте базу недвижимости, чтобы подать объявление о продаже или аренде недвижимости (квартиры, дома, комнаты, студии, коммерции, участка, бизнеса) в ",
                        locationState.case,
                        ". Разместить объявление бесплатно о продаже или аренде недвижимости."
                    ].join(""),
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "core",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Add_module_default()).content,
                        children: [
                            isAdded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "logo",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        style: {
                                            textAlign: "center"
                                        },
                                        children: "Отправлено"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            textAlign: "center",
                                            fontSize: 18,
                                            fontWeight: 500,
                                            lineHeight: 1.5
                                        },
                                        children: [
                                            "Наши модераторы уже проверяют Ваше объявление и скоро оно появится на сайте.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Через месяц наш бот в телеграмм напомнит Вам о продлении объявления",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Хотите добавить",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: handleResetClick,
                                                style: {
                                                    color: "#E8505B"
                                                },
                                                children: " еще?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.svg */.E.svg, {
                                        viewBox: "0 0 750 500",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                            cx: "212.87",
                                                            cy: "458.85",
                                                            rx: "128.13",
                                                            ry: "27.47",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            width: "750",
                                                            height: "500",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                            points: "43.79 334.5 54.6 410.77 98.59 410.77 110.94 333.73 43.79 334.5",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                            points: "597.27 139.81 567.86 182.2 577.94 190.86 608.43 147.68 597.27 139.81",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M659.62,152.11s-3.87,37.56,16.71,39.17,18.35-38.85,18.35-38.85Z",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M530,319s-53.43,7.82-86.65,49.51c0,0,9.77,15,28.66,32.58C522,447.54,640.76,476,713.73,375,713.73,375,661.61,296.15,530,319Z",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-7",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M154.86,305.67c-14,10.86-32.8,47-29,87.55,4.57,48.6,44.23,80,93.15,80,65.56-.09,103.74-39.38,92.32-75.87s-47.05-49.11-76.18-47.08a26.8,26.8,0,0,1-2.78-20.4s-18.33,1.41-26.77-25L197.82,318s-13.29-3.45-37.37,6.22Z",
                                                            fill: "none"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                        id: "clip-path-8",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M278,459.52s45.54-22.78,81.54-5.13c43.71,21.42,57.28,9.2,29.11-11.56-21.25-15.67-67.36-23.88-106.46-.57S278,459.52,278,459.52Z",
                                                            fill: "none"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "OBJECTS",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        x: "315.37",
                                                        y: "352.68",
                                                        width: "72.03",
                                                        height: "60.4",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M330.67,352.71S343,316.76,379.75,320c40.1,3.55,29.55,39.9,24.57,51.35-.71,1.64-4-.46-4.2.91-1.59,9.79.71,13.21,3.23,15.09,1.83,1.37-1.34,20.53-3.61,18.88-3.43-2.49-.61-7.64-8.85-15.68-6.3-6.15-19.16,4.68-19.66-20.45V352.71Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M408.09,359.7s-2.43,10,5.91,11.33a2.22,2.22,0,0,1,1.58,1.11c1.46,2.67,5.12,10.23,3.7,16.85,0,0-2.73,1-6.81-5.29-4.2-6.45-13.09-1.35-14.82-9S408.09,359.7,408.09,359.7Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M401.64,350s24.71-.36,22.49-28.64C422.44,299.79,404.39,291,390.74,293c-9.72,1.42-15.55,8.92-13.91,12.51l.05.09c1.33,2.91,10,3.15,13.16,3,7.1-.32,21,.63,24.38,14.4,4.44,17.94-13.73,22.53-18.78,20.63S401.64,350,401.64,350Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        x: "298.97",
                                                        y: "352.68",
                                                        width: "72.03",
                                                        height: "60.4",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M281.27,371.59,299,352.68h72l-18.28,19.14S281.75,371.12,281.27,371.59Z",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M403.51,387.15c-6.53-4.32-4.05-13.46-1.53-19.47,1.4-3.26,3.44-6.13,4.85-9.25a32.3,32.3,0,0,0,2.22-7.41l.43-2.58a30.08,30.08,0,0,1-1.94,10.29c-1.3,3.31-3.31,6.19-4.65,9.35-2.42,5.89-5.19,14.28.62,19.07Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M298.63,371.71c14-.42,29.49-.47,43.53-.49l14.51.06-.33.17c2.38-3.1,8.61-11.14,11-14.11l3.7-4.66-3.46,4.85c-2.25,3.15-8.28,11.37-10.65,14.6h-.22l-14.51.07c-14.06,0-29.55-.07-43.53-.49Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M371,413.08a381.9,381.9,0,0,1,0-39.46,376.37,376.37,0,0,1,0,39.46Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        opacity: "0.3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M389.18,326.84a17.54,17.54,0,0,1,9,5.41,62.7,62.7,0,0,1-9-5.41Z",
                                                                fill: "#263238"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M376.64,323.15a16.25,16.25,0,0,1,9.67,2.49,51.83,51.83,0,0,1-9.67-2.49Z",
                                                                fill: "#263238"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M369.13,322.82a6.11,6.11,0,0,1,5.39.08,9.17,9.17,0,0,1-5.39-.08Z",
                                                                fill: "#263238"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M384,327a6.11,6.11,0,0,1,5,1.94,9.26,9.26,0,0,1-5-1.94Z",
                                                                fill: "#263238"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M374.08,325.07a6.1,6.1,0,0,1,5.3,1,9.27,9.27,0,0,1-5.3-1Z",
                                                                fill: "#263238"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M318.76,407.53c-4.28.21-8.76.42-13.12.46v-.46c0-.37,0-5.29,0-5.49h.51c4.31,0,8.62.1,12.93.25-.07,1.79-.18,3.59-.27,5.24Zm0,0c-.09-1.75-.2-3.39-.27-5l.27.27c-4.22.15-8.44.24-12.66.23l.5-.5,0,5-.46-.47c4.23.06,8.35.27,12.66.47Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M324.13,405.14a2.21,2.21,0,0,0,4.42,0,2.21,2.21,0,0,0-4.42,0Zm0,0a2.71,2.71,0,0,1,5.42,0,2.71,2.71,0,0,1-5.42,0Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M24.66,412.37c224.45-.61,476.23-.61,700.68,0-224.45.62-476.23.62-700.68,0Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M638.28,445.07c17.51,1.29,35.17,2.27,52.42,5.76,9.66,2.07,15.53,9.08,3.88,14.43-9.21,3.84-20.47,4.69-29.71.49-14.14-7.1,11-14.25,16.51-16.36,11.83-4.1,24.09-7.13,35.52-12.3,5.32-2.56,9.45-5.69,1.51-8.7-7-2.58-14.58-3.58-22-4.69-9.93-1.41-19.93-2.4-29.94-3.28,6.73.76,61.4,3.24,56.9,12.77a8,8,0,0,1-2.79,2.78,55.21,55.21,0,0,1-10.31,4.8c-4.71,1.77-9.5,3.31-14.28,4.86-9.49,3.14-19.23,5.86-28.25,10.18-2.28,1.27-8.2,4-5.42,7.09,4.67,4,11.41,4.74,17.41,4.66a39.39,39.39,0,0,0,14.48-3.09c11-4.89,5-11-3.69-13-17.18-3.59-34.79-4.86-52.25-6.44Z",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        cx: "212.87",
                                                        cy: "458.85",
                                                        rx: "128.13",
                                                        ry: "27.47",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                        cx: "212.87",
                                                        cy: "458.85",
                                                        rx: "128.13",
                                                        ry: "27.47",
                                                        fill: "#fff",
                                                        opacity: "0.7"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                        "clip-path": "url(#clip-path)",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M80.74,479.51a158,158,0,0,0,17.13-7.92c11-5.89,22.18-12.21,31.13-21.06,4.15-4.2,8.69-10.61,5-16.43-2.48-6.6,8-10.15,12.65-11.88A126.51,126.51,0,0,1,165,417.81a210.22,210.22,0,0,1,37.65-3.06c4.72.27,9.69.09,14.07,2.18,2.15,1.23.92,3.07-.34,4.38-4.48,4.52-9.82,7.93-14.91,11.67-15.6,11.68-60,39.57-47.28,62.43,10.35,17.38,42.2,18.48,60.34,17.18,6.18-.57,12.54-1.28,18.38-3.41.91-.38,3.82-1.49,2.71-2.71-3-3.5-4.39-8.13-5.52-12.51a49,49,0,0,1-.72-18.91c2-12.67,10.19-23.68,20.89-30.49,16.09-10.28,35.42-13.6,54.14-15.26,4.58-.15,30.45-3.41,29.44,2.68-.68,2.4-2.89,3.87-4.65,5.42-5,3.9-10.29,7.28-15.44,10.9-10.66,7.73-29.56,20.26-28.92,35a17,17,0,0,0,3.29,8.71,16.73,16.73,0,0,1-1.43-17.86c5.84-11.32,16.82-18.78,26.85-26.12,5.12-3.65,10.43-7.07,15.34-11,1.69-1.48,3.79-2.94,4.45-5.13.93-5.93-33.74-1.44-38.26-1A132.18,132.18,0,0,0,267.56,437c-17.86,5.95-34.35,18.55-37.4,38.14a48.1,48.1,0,0,0,.75,18.59c1.11,4.26,2.43,8.71,5.32,12.1,4,5.18-18.67,7.43-21.63,7.63-19.27,1.48-56.2.15-63.07-22.09-6-24.54,40.25-51.5,57.16-64.55,3-2.41,6.52-4.52,8.46-7.83.52-2-3.77-2.52-5.16-2.84-17.62-2.57-58.69,1.29-73.74,10.38-2.48,1.52-5.21,4.25-3.84,7.34,3.79,6-.87,12.64-5.15,16.87-9,8.84-20.23,15.08-31.34,20.92a155.22,155.22,0,0,1-17.18,7.81Z",
                                                            fill: "#fff"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M211.69,372.24c-.13,1.85,0,3.71-.06,5.53.14,4.06-1-.35-1-1.83a5.82,5.82,0,0,1,1.06-3.7Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M214.83,371.08a57.37,57.37,0,0,0,1.49,8.09,7.81,7.81,0,0,1-1.49-8.09Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M248.85,349.94a27.05,27.05,0,0,0,6.5-2.41,5.46,5.46,0,0,1-6.5,2.41Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M252.1,353.06a8.71,8.71,0,0,1,5.89-.24,8.7,8.7,0,0,1-5.89.24Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M238.45,340a9.72,9.72,0,0,1-2.72,5.61,9.66,9.66,0,0,1,2.72-5.61Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M241.91,341.69a6.41,6.41,0,0,1-2.64,4.29,6.45,6.45,0,0,1,2.64-4.29Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M206.74,358a14.31,14.31,0,0,1,7.6.16,14.21,14.21,0,0,1-7.6-.16Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M209.38,361a8.53,8.53,0,0,1,5.78-.83,8.53,8.53,0,0,1-5.78.83Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M258.71,347.05c.26,1.86,4.37,1.41,4.79,0-.42-1.4-4.53-1.86-4.79,0Zm0,0c.36-2.1,5.63-2.5,5.79,0-.17,2.49-5.43,2.1-5.79,0Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "298.63",
                                                        cy: "91.31",
                                                        r: "3.59",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "72.86",
                                                        cy: "98.82",
                                                        r: "3.59",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "709.98",
                                                        cy: "55.08",
                                                        r: "3.59",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "309.42",
                                                        cy: "265.39",
                                                        r: "3.59",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M343.6,229.35c-1,1.79-2.82,4.75-4.68,6a.82.82,0,0,0,0,1.35,12,12,0,0,1,4.34,5.08.81.81,0,0,0,1.42.13,18.66,18.66,0,0,1,5.16-5.37.82.82,0,0,0,.12-1.34,20.22,20.22,0,0,1-4.94-5.84A.81.81,0,0,0,343.6,229.35Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M522.13,229.27c-1,1.79-2.81,4.75-4.67,6a.8.8,0,0,0,0,1.34,11.89,11.89,0,0,1,4.34,5.08.81.81,0,0,0,1.42.13,18.66,18.66,0,0,1,5.16-5.37.8.8,0,0,0,.12-1.33,20.29,20.29,0,0,1-4.94-5.85A.81.81,0,0,0,522.13,229.27Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M185,185.13a3.35,3.35,0,0,0,6.69,0,3.35,3.35,0,0,0-6.69,0Zm0,0a3.85,3.85,0,0,1,7.69,0,3.85,3.85,0,0,1-7.69,0Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M486.08,91.31a3.35,3.35,0,0,0,6.69,0,3.35,3.35,0,0,0-6.69,0Zm0,0a3.85,3.85,0,0,1,7.69,0,3.85,3.85,0,0,1-7.69,0Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M618.57,228.93a3.35,3.35,0,0,0,6.69,0,3.35,3.35,0,0,0-6.69,0Zm0,0a3.85,3.85,0,0,1,7.69,0,3.85,3.85,0,0,1-7.69,0Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M266.71,108.28c-1.58,2.86-4.5,7.59-7.48,9.6a1.29,1.29,0,0,0,0,2.14,19.07,19.07,0,0,1,6.95,8.13,1.3,1.3,0,0,0,2.27.21c1.75-2.58,4.86-6.62,8.25-8.59a1.3,1.3,0,0,0,.19-2.13,32.69,32.69,0,0,1-7.9-9.34A1.29,1.29,0,0,0,266.71,108.28Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M51.54,54.77c-1,1.79-2.82,4.75-4.68,6a.82.82,0,0,0,0,1.35A11.89,11.89,0,0,1,51.2,67.2a.81.81,0,0,0,1.42.13A18.66,18.66,0,0,1,57.78,62a.82.82,0,0,0,.12-1.34A20.22,20.22,0,0,1,53,54.78.81.81,0,0,0,51.54,54.77Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M522.94,32.39a3.25,3.25,0,1,1-3.25-3.25A3.25,3.25,0,0,1,522.94,32.39Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M456.87,293.31a3.25,3.25,0,1,1-3.25-3.25A3.26,3.26,0,0,1,456.87,293.31Z",
                                                        fill: "#ebebeb"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        "clip-path": "url(#clip-path-2)",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M551.05,86.21s-23.81,12.7-19.89,21.93S554.9,100.9,555.59,88c0,0,13.79-24.81,2.5-30.36C548.36,52.9,548.42,76.72,551.05,86.21Z",
                                                                fill: "none",
                                                                stroke: "#ebebeb",
                                                                "stroke-miterlimit": "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M553.54,81c4.84.83,8.36,3.8,7.88,6.64s-4.81,4.45-9.65,3.61-8.37-3.8-7.88-6.63S548.7,80.12,553.54,81Z",
                                                                fill: "#ebebeb"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M559.53,87.53C592.93,88,615.4,64,602.9,31c-6.47-15.16-16,1.5-7.34,11.26,6.58,7.6,18.46,10.15,28.15,9,16.88-2.07,28.89-18.65,28.64-35.18a37.65,37.65,0,0,1-7.49,23.36c-7.6,10.32-21.15,15-33.56,12.13-10-1.78-21.68-9.11-20.07-20.67.44-4.43,4.69-9.49,9.09-5.66a14.56,14.56,0,0,1,3.47,5.38c2.87,7.86,4.28,16.37,3,24.7-3.33,22.31-26.51,33.28-47.22,32.17Z",
                                                                fill: "#ebebeb"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M202,230.64s22.34,13.09,27.93,5.26S212,220.11,201.18,226c0,0-27.22,1.17-26.09,13.2C176.06,249.56,195.52,237.55,202,230.64Z",
                                                                fill: "none",
                                                                stroke: "#ebebeb",
                                                                "stroke-miterlimit": "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M196.41,231.24c-1.75-4.37-1.09-8.75,1.47-9.77s6.06,1.69,7.8,6.07,1.09,8.76-1.47,9.78S198.16,235.62,196.41,231.24Z",
                                                                fill: "#ebebeb"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M198.78,223c-12.38-21.52-37.9-33.29-59.13-16.19-3.84,3-15.81,14.18-11,19.06,1.69,1.39,4.2.61,5.82-.62,6.18-5.15,5.37-14.42,3.7-21.56-10.48-40.53-52.41-71.18-94.35-67.37,21-2.45,42.37,4.43,59.42,16.6s30.56,30,35.9,50.53c1.22,5.12,1.77,10.61.24,15.8-1.13,3.81-4,7.83-8.23,8.2a4.23,4.23,0,0,1-3.45-1.32c-4.37-6,7.11-16.38,11.5-19.88,21.71-17.2,47.26-5.36,59.56,16.75Z",
                                                                fill: "#ebebeb"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M56.67,338.19c-.23-14.36-8.17-25.66-22.14-29.65a33.36,33.36,0,0,1,4.89,1.33c11.74,3.93,18.52,16.27,17.25,28.32Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M61.31,341.75c5.56-7.93,6.91-19.37.59-27.26-2.84-4-7.57-6.28-10.16-10.53-2.81-4.23-2.66-9.66-1.35-14.36,2.51-9.26,7.31-18.73,3.92-28.31-1.08-3-2.62-6-3.63-9.07-4.15-10.44-11.7-47.47,5.13-49.06a18.43,18.43,0,0,1,13.89,4.6C79.69,216.63,83,231,82,243.88c-.64,6.5-2.27,12.85-2.57,19.36-.94,10.1,9.72,17.42,8,27.65-1.25,9.77-10.76,17.49-5.73,27.66,3,7.86,3.13,21.35-1.42,28.53a13,13,0,0,0,2-4.43,39.94,39.94,0,0,0-.88-24c-5.25-10.27,4.23-18.09,5.49-27.87,1.54-10.18-9.16-17.46-8.17-27.6.27-6.54,1.88-12.93,2.49-19.39.86-12.61-2.38-26.7-12.16-35.33a17.72,17.72,0,0,0-13.18-4.36c-8.83.76-9.56,12.33-9.68,19.25A91,91,0,0,0,51.38,252c1,3.12,2.5,6,3.6,9.09,3.43,9.68-1.48,19.5-4,28.67-1.3,4.63-1.48,9.8,1.22,13.95s7.25,6.51,10,10.58c6.28,8,4.83,19.56-.88,27.48Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M96.14,340.19a21,21,0,0,1,6.15-15.95,20.73,20.73,0,0,0,2.94-3.16,10.07,10.07,0,0,0,1.51-3.94,32,32,0,0,0-.19-8.62c-.71-5.77-1.14-12.1,1.94-17.34,4.51-7.54,11.92-13,15-21.26,2.08-5.64-2.36-11.23-7.41-13.37a14.49,14.49,0,0,0-15.74,3.22c-2.06,2.09-3.15,4.75-4.3,7.44a20.08,20.08,0,0,1-5.18,7.06,15.49,15.49,0,0,1-3.82,2.15,5.2,5.2,0,0,0-1.81,1.16,3.49,3.49,0,0,0-.73,2,3.62,3.62,0,0,1,.67-2.06c1.55-1.55,3.94-1.93,5.52-3.47,3.43-2.85,4.85-7.13,6.65-11.09a15.13,15.13,0,0,1,19.07-7.22c5.49,2.26,10.2,8.37,8,14.45-3,8.4-10.66,14-15.14,21.43a18.38,18.38,0,0,0-2.34,8.14c-.45,5.82,1.37,11.64.42,17.48-.41,3-2.5,5.48-4.73,7.33a21,21,0,0,0-6.49,15.61Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M60.9,221.5c5.39,8.47,6.28,19.06,5.41,28.86A45,45,0,0,0,67.49,265c1.64,7.29,6,13.83,6.42,21.41-.47,9.81-4.76,19.61-1.83,29.38.32,1.07,1.24,4.31,1.45,5.4a45.09,45.09,0,0,1,.21,16.7A46.9,46.9,0,0,0,73,321.29c-.23-1.1-1.2-4.23-1.55-5.35-3.19-9.81,1-19.72,1.48-29.52-.54-7.4-4.77-14-6.34-21.22a43.84,43.84,0,0,1-1.06-14.92c1-9.73.33-20.14-4.65-28.78Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M111.48,267.16a18.13,18.13,0,0,0-12,13.84c-.63,3.14-.36,6.35-.52,9.64a31.4,31.4,0,0,1-1.86,9.66c-1.17,3.09-2.91,5.85-3.92,8.88-1.92,6.1-2,12.75-2.54,19.12-.21,3.23-.32,6.47-.38,9.71a152.3,152.3,0,0,1,.4-19.46,39,39,0,0,1,1.66-9.66c1-3.16,2.75-6,3.85-8.95A30.26,30.26,0,0,0,98,290.59c.19-3.22-.07-6.55.68-9.74a18,18,0,0,1,12.76-13.69Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                        points: "43.79 334.44 54.6 410.71 98.59 410.71 110.94 333.67 43.79 334.44",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                        "clip-path": "url(#clip-path-3)",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M42,342.66c25.37-.43,50.88-.18,76.24.74-25.37.43-50.89.18-76.24-.74Z",
                                                            fill: "#fff"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        x: "47.47",
                                                        y: "403.56",
                                                        width: "61.31",
                                                        height: "8.47",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M67.67,370.76A23.8,23.8,0,0,0,69.52,380c1.79,4.46,6.65,8.12,10.67,3.77,5.53-6.38,5.53-19.71,0-26.1-4-4.35-8.88-.7-10.67,3.77a23.8,23.8,0,0,0-1.85,9.28Zm0,0c0-4.71,1-9.78,4.24-13.4a5.8,5.8,0,0,1,8.76-.14c6.18,6.52,6.18,20.55,0,27.07a5.79,5.79,0,0,1-8.76-.13c-3.23-3.62-4.21-8.69-4.24-13.4Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                        points: "597.57 139.77 568.16 182.17 578.24 190.82 608.73 147.65 597.57 139.77",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                        points: "609.66 118.38 608.36 191.04 624.79 191.04 628.11 117.98 609.66 118.38",
                                                        fill: "#f2b7c3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                        points: "615.3 124.95 622.17 124.95 619.15 185.13 614.29 184.96 615.3 124.95",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M636.54,118.35c-.08,21.49-.21,51.84-.49,73l-.47-.48,12.09,0-.5.48c.64-20.71,1.72-52.58,2.58-73l.15.15-13.36-.07Zm0,0,13.36-.23h.15c0,.08-.41,18.32-.4,18.43-.24,11.59-1.13,42.82-1.48,54.8l0,.49h-.48l-12.09,0h-.48c.26-21.39,1-51.79,1.44-73.46Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M642.53,132.69c.48,15.33.3,30.77-.56,46.09-.49-15.34-.3-30.78.56-46.09Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        "clip-path": "url(#clip-path-4)",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M591.48,143a100.24,100.24,0,0,1,16.2,12.21A100,100,0,0,1,591.48,143Z",
                                                                fill: "#fff"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M568.23,176.65a99.8,99.8,0,0,1,16.2,12.21,100,100,0,0,1-16.2-12.21Z",
                                                                fill: "#fff"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M668.29,153.42c3-10.27.86-21.37-3.26-31-2.47-5.17-5.23-10.27-7-15.74-3-8.26-5.54-24.46,7.59-24.07,7.11,0,11.76,6.64,14.49,12.43,8,18,7.39,39.74-1,57.44,7.84-17.76,8.08-39.28.19-57-2.68-5.51-6.92-11.82-13.69-11.82-12.26-.41-9.42,15.15-6.75,22.79,1.73,5.45,4.37,10.57,6.76,15.75,4.06,9.76,6,21,2.66,31.28Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M685.05,153.09c4.5-8.1,9.81-16.1,11.47-25.36,1.05-5.58,2.21-16.23-4.92-18a12.88,12.88,0,0,0-6.8.84,17,17,0,0,1,3.33-1.14c10.73-2.44,10.94,11.38,9.37,18.5-1.78,9.36-7.22,17.41-12.45,25.17Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M667.4,97.45c10.49,15.06,12.84,35.38,6.87,52.63l-1.21,3.45,1-3.52a68.13,68.13,0,0,0-6.62-52.56Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M659.74,152.15s-3.87,37.56,16.72,39.16,18.34-38.84,18.34-38.84Z",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                        "clip-path": "url(#clip-path-5)",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M654.75,158.23c16-.67,32-.67,48,0-16,.67-32,.67-48,0Z",
                                                            fill: "#fff"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        x: "551.58",
                                                        y: "191.09",
                                                        width: "166.56",
                                                        height: "9.55",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M311,156.18c-.21,25.28,16.06,49.6,39.62,58.84C392.1,232,438.2,201,438,156.18c.2-44.82-45.89-75.79-87.36-58.83-23.55,9.23-39.83,33.54-39.62,58.83Zm0,0c-.36-25.41,15.92-49.74,39.38-59.42,42.44-17.91,89.53,13.36,89.6,59.42s-47.16,77.32-89.6,59.41c-23.46-9.68-39.74-34-39.38-59.41Z",
                                                        fill: "#263238"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "cat2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M530,319.18s-53.43,7.82-86.65,49.51c0,0,9.77,15,28.66,32.58,50,46.5,168.74,74.92,241.71-26.06C713.73,375.21,661.61,296.38,530,319.18Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M530,319.18s-53.43,7.82-86.65,49.51c0,0,9.77,15,28.66,32.58,50,46.5,168.74,74.92,241.71-26.06C713.73,375.21,661.61,296.38,530,319.18Z",
                                                        fill: "#fff",
                                                        opacity: "0.7"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                        "clip-path": "url(#clip-path-6)",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M480.73,424.61c2.58-1.95,4.94-4.42,7.51-6.39,20.35-16.73,42.77-20,60.71,1.95,6.32,7.69,10,17,14.13,25.95,3.89,8.5,9,16.39,19.52,15.59,15.5-.64,81.66-8.47,50-33.18C608.88,410.75,569.93,393.86,560,364c-4.29-12.94.71-26.9,8.91-37.15,12-15.06,28.58-30.38,49.12-29.69,20.7,1,35.52,20.67,37.92,40.11.77,6.58.12,13.16.63,19.75,1.17,22.69,8.51,47.39,36,44.95a70.2,70.2,0,0,0,16.68-3.8c2.39-.86,6.9-2.67,9.61-2.67,11-.22,7.69,14.07,5.39,20.69-11.2,30.18-35,57.45-59.85,77.4-30.64,24.54-71.79,39.53-110.83,29-38.41-10-72.41-34-96.54-65.33-17.78-23.44-32.42-50.7-36.21-80.2-.82-7.11-.6-22.7,10.36-19.15,1.15.4,2.36.78,3.51,1.14a169.88,169.88,0,0,0,58.47,6.44c14.68-1,39.27-6.52,31.26-26.4-9.43-23-38.78-24.7-60.15-22-3.27.43-6.51,1-9.71,1.74s-6.49,1.49-9.25,3.29c2.75-1.81,6.09-2.49,9.24-3.32s6.45-1.33,9.71-1.77c21.43-2.78,50.9-1,60.41,22C532.85,359.18,508.1,365,493.21,366a166.12,166.12,0,0,1-62.2-7.49c-13.55-4.09-9.75,21.09-8.05,28.29,12.46,50.91,48.14,96,94.22,120.78,23.09,12.16,49.33,20.31,75.62,16.89,52-6.67,96.61-46.81,122.34-90.72a108.36,108.36,0,0,0,8.19-17.83c3.09-8.86,5.26-23.35-9.12-18.48-12.1,4.51-26.3,8.55-38.65,2.8-15.71-7.79-18.83-27.35-19.87-43.14-.5-6.54.15-13.18-.6-19.69a56.92,56.92,0,0,0-2.18-9.53c-5-15.31-18.17-29.14-35-29.91-20.25-.69-36.63,14.5-48.52,29.35-13.95,17.7-13.76,36.23.72,53.51C582.89,396,600.06,406.42,616.57,417c5.54,3.55,11.14,7,16.37,11.07,3.82,3,8,6.69,8.61,11.81.94,13.13-27,18-36.83,19.8-6.5,1.07-13.06,1.83-19.63,2.28-2.84.18-5.89.36-8.64-.49C566.17,458.23,563,446,558.72,437.27c-7.43-17.71-23.16-35.74-44.25-32-11.44,1.93-21.41,8.67-30,16.19l-1.84,1.63a15.68,15.68,0,0,1-1.91,1.56Z",
                                                            fill: "#fff"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M443.36,368.69c21.2,8.67,43.67,14,66.17,18,35.25,6,71.3,7.28,107,5,12.41-.9,26.09-2.38,38.4-4.21,9.66-1.43,20-3.4,29.59-5.3s19.82-4.5,29.25-7c-9.38,2.59-19.64,5.19-29.16,7.37a487.55,487.55,0,0,1-89.5,10.95c-40.1,1.06-80.46-3.22-119.22-13.67a244.72,244.72,0,0,1-32.49-11.17Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M588.07,344.5h-1.18c-2.77,0-5.58,0-8.43-.15h-.24A159.08,159.08,0,0,1,555,341.58h0c-3.82-.75-7.69-1.66-11.58-2.74-1.51-.42-3-.87-4.55-1.34l-.07,0-1.85-.59-2.46-.83c-.7-.24-1.4-.48-2.11-.74l-1.72-.63-.19-.08c-.37-.13-.75-.28-1.12-.43-.53-.19-1-.4-1.57-.61l-2.08-.84a158.92,158.92,0,0,1-14.41-6.84h0c-2.18-1.17-4.37-2.41-6.55-3.71a73.13,73.13,0,0,1-.12-7.86c.54-15.87,5.93-50.64,42.53-54.64,47.61-5.21,50.59,26.78,76.63,35s38.69,11.9,47.61,28.26C671.33,322.91,635.86,343.82,588.07,344.5Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M672.87,373.09l-17-8.69s-10.61,9.51-32.63,7.06h0c-.13.37-5.43,16.1-5.88,16.87,0,0-19-8.9-26.67-27.67a43.81,43.81,0,0,1-2.12-25.91c7.53-36.56,70.47-36.75,82.75-11.85a56.75,56.75,0,0,1,5.43,18.42A68.19,68.19,0,0,1,672.87,373.09Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M519.17,296.84a255.89,255.89,0,0,1-23.11-14.52c-11.9-8.54-24.4-6.3-21.73,2.78s26.31,28.71,45.52,25S519.17,296.84,519.17,296.84Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M544.93,280.75s10.67-15.48,11.21-32.56S578,246.05,567.88,269,544.93,280.75,544.93,280.75Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M630.57,301.69s8.87-23.23-4.47-31.77-18.25.25-12.64,9c3.67,5.71,7.5,5.72,0,18.53S630.57,301.69,630.57,301.69Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M613.65,328.92c0,6.28,14.27,18.62,23.29,18.62s9.36-12.34,9.36-18.62-3.14-13.27-12.16-13.27S613.65,322.65,613.65,328.92Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M591,283.68c0,10.48-12.89,19-28.79,19s-28.79-8.49-28.79-19,8.95-21.15,26.78-20.3C576.12,264.13,591,273.2,591,283.68Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M632.7,337.84a6.38,6.38,0,0,1,2.68-2.4,9,9,0,0,1,4.3-.62l-.6,7.11Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M566.71,305.23c-.08-.51-.62-4-.72-4.57-3.57-18.05,5.82-20.54,12.11-15.68,3.13,2.42,6.41,7.94,8.15,12",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M610,320.36c3-7.22,10.92-11.34,18.51-11.5,1.08,0,2.17.06,3.25.13-1.56.19-3.26.32-4.8.62-6.77,1.17-13.22,4.86-17,10.75Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M634.39,330.78c1.89,1.69,3.44,4.54,2.61,7.09-.62-2.56-1.87-4.55-2.61-7.09Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M585.52,295.64a13.84,13.84,0,0,1,2.55,9.53c-.93-3.24-1.93-6.21-2.55-9.53Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M557.91,317s11,1.57,8.36-14.81",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M557.91,317c7-.17,8.59-6.45,8.4-12.3,0-.83-.06-1.66,0-2.51.2.82.35,1.64.53,2.47,1.16,6.08-1.46,13.64-8.89,12.34Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M554.27,259.24a27.42,27.42,0,0,1,16.24,1.27,160.27,160.27,0,0,0-16.24-1.27Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M649.6,317.7a226.67,226.67,0,0,1,25.5-16.52,225.28,225.28,0,0,1-25.5,16.52Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M652.83,320.58a166.26,166.26,0,0,1,26.22-6.11,191.77,191.77,0,0,1-26.22,6.11Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M649.26,313.78a187,187,0,0,1,18.3-20.86,189,189,0,0,1-18.3,20.86Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M604,339.75c-12.9,6.51-26.19,12.44-39.65,17.71C577.21,351,590.49,345,604,339.75Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M599.9,346.24a210.29,210.29,0,0,1-22.68,18.7,211.48,211.48,0,0,1,22.68-18.7Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M627.11,335.77c-2.83-5.27,3.45-8.36,7.56-5.2l-.78.52c-.52-2,.48-4.44,2.73-4.66a3.76,3.76,0,0,1,4.43,2.71,4.12,4.12,0,0,0-1.84-1.83c-1.37-.62-3.58-.25-4.21,1.2a4,4,0,0,0-.15,2.34l.27,1.21a9.34,9.34,0,0,0-3.68-1.78c-3.31-.61-5.54,2.39-4.33,5.49Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M508.71,290.37c3.84,1.57,8,1.47,12.06,2.13-4,.76-8.88.7-12.06-2.13Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M505.06,308.77a10.17,10.17,0,0,1,8.26,5.43,46.93,46.93,0,0,0-8.26-5.43Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M569.27,283.33a8.08,8.08,0,0,1,2.75,6.19,20.36,20.36,0,0,1-2.75-6.19Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M572.61,282.55a7,7,0,0,1,3.44,5.21,17.12,17.12,0,0,1-3.44-5.21Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M611.53,269.57a4.42,4.42,0,0,1,3.11.85c1.09.67,3.29,3.79.65,1.69-1.23-.88-2.43-1.72-3.76-2.54Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M614.92,266.39a5.48,5.48,0,0,1,5.44,3.86,48.41,48.41,0,0,0-5.44-3.86Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M474.08,281.47c2.7,1.47,4.79,3.42,7.27,5.21-3-.49-5.56-2.77-7.27-5.21Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M476.5,278a14.67,14.67,0,0,1,8.24,4.36A40.87,40.87,0,0,1,476.5,278Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M559.42,240.71a5.94,5.94,0,0,1,2.57,5.48,23,23,0,0,1-2.57-5.48Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M562.57,241.06a6.24,6.24,0,0,1,2.69,5.37,17.59,17.59,0,0,1-2.69-5.37Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M587.38,344.51c-2.15,0-4.83,0-8.92-.15h-.24A159.08,159.08,0,0,1,555,341.58h0c-3.82-.75-7.69-1.66-11.58-2.74-1.51-.42-3-.87-4.55-1.34l-.07,0-1.85-.59-2.46-.83c-.7-.24-1.4-.48-2.11-.74l-1.72-.63-.19-.08c-.37-.13-.75-.28-1.12-.43-.53-.19-1-.4-1.57-.61l-2.08-.84a10.34,10.34,0,0,1,9.3-2.71,12.43,12.43,0,0,1,4,1.3,29.62,29.62,0,0,0,19,3.5,75.23,75.23,0,0,0,11-2.91C584.3,324.29,589.35,336.2,587.38,344.51Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M598.35,338.69a334.72,334.72,0,0,1-36.18,8.43,339.52,339.52,0,0,1,36.18-8.43Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M605.23,372.49l8.93,8.22L617,370.14S610.4,369.9,605.23,372.49Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M660.66,360.27l9.4,6.11,1.64-12.68S663.48,356,660.66,360.27Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M610.85,376.45c-.46-1.48-.59-7.63,2-4.44a13.31,13.31,0,0,1,1.67,3.38c-1.11-1-1.89-2.41-2.92-3.28,0,0,.19,0,.21-.08l0,.06c-.49,1.4-.54,2.91-1,4.36Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M666.82,363c-.48-.93-3-7.76-.11-6.19a14.25,14.25,0,0,1,3.53,3.85c-1.38-.92-3-2.37-4.16-3.11a.41.41,0,0,0,.22-.1c.09-.09.06-.1.07-.08-.07,1.76.48,3.81.45,5.63Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M607.78,352.8s6.83-15.46,21.59-3.49C629.37,349.31,616.56,362,607.78,352.8Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M616.64,344.91s-2.23,7.34,3.41,10.23C620.05,355.14,622.41,347,616.64,344.91Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M648.55,340.9s-1.12-14.61,17.43-10.45C666,330.45,664.32,345.38,648.55,340.9Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M654.35,331.06s1.28,7.58,7.61,7.65C662,338.71,660.46,330.37,654.35,331.06Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M655.88,364.4s-9.83,12.11-32.64,7.06a12.83,12.83,0,0,1,7-8.13c.85-.39,2.15.48,2.46,1.36a2.36,2.36,0,0,0,1.51,1.62c1.32.4,2.08-1.45,2.52-3.53a4.31,4.31,0,0,1,3.26-3.34h.07a4.35,4.35,0,0,1,4.93,3c.52,1.54,1.24,2.64,2.21,2.21a3.15,3.15,0,0,0,1.38-2.55c.17-1.05,1.23-1.21,2.18-.73C652.45,362.17,654.13,363.41,655.88,364.4Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M493.36,336.31c-2.35,6.28-1.95,10.9-.31,14.6,4,9.06,15.37,12.5,11.56,20.84-5.12,11.22-24.26,7.46-32.59-9.1a38.64,38.64,0,0,1-3.91-17.52c0-25,26.67-29.87,36.45-30.81,2.2-.21,3.54-.22,3.54-.22l14.58,10.47a74.39,74.39,0,0,0-11.45,1.32C504,327.32,495.63,330.26,493.36,336.31Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M504.61,371.75c-4.41,9.66-19.21,8.21-28.56-2.95a9,9,0,0,1,.49-12l.06-.06.18-.18a14.29,14.29,0,0,1,20.51.51C502,362.1,507.43,365.59,504.61,371.75Z",
                                                        opacity: "0.3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "cat1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M154.88,305.48c-14,10.86-32.8,47-29,87.54,4.58,48.61,44.24,80.05,93.16,80,65.56-.08,103.74-39.37,92.32-75.86S264.33,348,235.19,350.06a26.85,26.85,0,0,1-2.78-20.4s-18.32,1.4-26.76-25l-7.82,13.22s-13.28-3.45-37.36,6.22Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M181.11,337.37a20.08,20.08,0,0,1-2.79,2.4,27.74,27.74,0,0,1-6.35,3.44,28.14,28.14,0,0,1-13.81,1.6S163.15,326.31,181.11,337.37Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M178.32,339.77a27.74,27.74,0,0,1-6.35,3.44,23,23,0,0,1,2.34-6.57A12.08,12.08,0,0,1,178.32,339.77Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M217.29,327.43a21.78,21.78,0,0,1-10.39,5.72,23,23,0,0,1-5.89.64,24.17,24.17,0,0,1-2.76-.19S202.38,318.25,217.29,327.43Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M206.9,333.15a23,23,0,0,1-5.89.64,19.49,19.49,0,0,1,1.74-4.44A9.44,9.44,0,0,1,206.9,333.15Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M304,381s-30,9.39-28.89-3.1,2-15.83-17.49-22.13-4.09-11.8,9.51-16.88c5.7-2.13,12-2.81,17.41-1.49,5.8,1.43,10.48,5.17,12,11.93a24.65,24.65,0,0,1,.5,6.51A42.18,42.18,0,0,0,304,381Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M278,459.53s45.54-22.78,81.54-5.13c43.71,21.42,57.28,9.2,29.11-11.56-21.25-15.67-67.37-23.88-106.46-.57S278,459.53,278,459.53Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M188.63,341.42s6.07-3.37,9.56-2.88L197,345.88S191.54,342.23,188.63,341.42Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M261.17,357c3.63.11,7.35,0,11,0a14.56,14.56,0,0,1-11,0Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M284.63,418a2.32,2.32,0,0,0,4.63.41,2.32,2.32,0,0,0-4.63-.41Zm0,0a2.82,2.82,0,0,1,5.62.5,2.82,2.82,0,0,1-5.62-.5Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M155.07,325.36l-1.28-9.42a57.26,57.26,0,0,0-6.88,12.37Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M265.25,378.46c11.67-.52,23.78-1.82,35.41-3.16a119.58,119.58,0,0,1-35.41,3.16Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        "clip-path": "url(#clip-path-7)",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M162.76,466.33s8.34-18.12,31.54-16.51,19.58,32.26,19.58,32.26S177.54,486.94,162.76,466.33Z",
                                                                opacity: "0.3"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                                                cx: "143.43",
                                                                cy: "440.08",
                                                                rx: "15.89",
                                                                ry: "13.93",
                                                                transform: "translate(-307.6 544.06) rotate(-84.93)",
                                                                opacity: "0.3"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                        "clip-path": "url(#clip-path-8)",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M357.68,428c-.48,5.38-6.55,10.09-13.28,8.63-8.91-1.93-7.65-8.59-3.89-11.84,4.08-3.53-1.24-8.23,5.61-7.62S358.15,422.62,357.68,428Z",
                                                                opacity: "0.3"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M398.26,470.2c-.1,5.39-13.11,4-20,3.37s-12-5.46-11.55-10.84,6.4-9,13.28-8.62C390.24,454.61,398.44,461.41,398.26,470.2Z",
                                                                opacity: "0.3"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M296.56,349.28a8.76,8.76,0,0,1-12-11.93C290.33,338.78,295,342.52,296.56,349.28Z",
                                                        opacity: "0.3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M180.75,348.27a339.15,339.15,0,0,1-36.93,4.14,339.15,339.15,0,0,1,36.93-4.14Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M163.42,357.69a77.46,77.46,0,0,1,17-5.66,78,78,0,0,1-17,5.66Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M209.77,337.71a125.66,125.66,0,0,1,18.46-13.19,124.19,124.19,0,0,1-18.46,13.19Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M235.77,328.29a81.88,81.88,0,0,1-15.83,9.42,82.7,82.7,0,0,1,15.83-9.42Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                                        points: "201.96 319.27 204.28 314.37 208.09 319.95 201.96 319.27",
                                                        opacity: "0.3"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.g */.E.g, {
                                                initial: {
                                                    rotate: -0
                                                },
                                                animate: {
                                                    rotate: 360
                                                },
                                                transition: {
                                                    duration: 5,
                                                    ease: "linear",
                                                    repeat: Infinity
                                                },
                                                id: "boul2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "230.79",
                                                        cy: "373.8",
                                                        r: "35.1",
                                                        transform: "translate(-196.72 272.67) rotate(-45)",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M213.93,343.79a81,81,0,0,0,43.85,20.62c2.32.42,4.67.45,7,.7a68.42,68.42,0,0,1-50.87-21.32Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M206.7,362C224.2,373,245,377.64,265.4,378.38l-3.87,0c-19.18,0-39.15-5.08-54.83-16.39Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M252.91,401a51.25,51.25,0,0,1-15.48-25.41c.52,1.14,1,2.31,1.52,3.43a91.08,91.08,0,0,0,14,22Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M259.11,394.34a42.17,42.17,0,0,1-12.75-17,168.91,168.91,0,0,0,12.75,17Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "230.59",
                                                        cy: "373.88",
                                                        r: "35.1",
                                                        transform: "translate(-94.22 78.15) rotate(-16.02)",
                                                        fill: "none"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                id: "cat1_lapi",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M192.26,425.37s15.42.22,14.11-30.2,12.31-29.21,18.8-12.05,16.8,23.22,11.88,33.64-18.46,1.8-15.23,16.95",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M237.53,407.51a9.51,9.51,0,0,1-1.81,8.89,10.84,10.84,0,0,0-3.16,8.05,26.43,26.43,0,0,0,3.85,12.9,12.74,12.74,0,0,0,2.86,3.55,11.74,11.74,0,0,1-3.27-3.28c-3.41-5.08-5.78-11.82-3.58-17.86a10.56,10.56,0,0,1,2.73-3.87,9.84,9.84,0,0,0,2.38-8.38Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M183.59,424.39c-5.76-11.7-2.44-23.17,11.49-25.22A43.18,43.18,0,0,1,206,399a59.21,59.21,0,0,0-10.81,1c-13.41,2.52-16,12.73-11.63,24.46Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M173.16,368.31s23.11-18.71,39.9-11.58c13.12,5.57-16.92,10.6-27.51,27.8S173.16,368.31,173.16,368.31Z",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M195.82,374.52c-9.9,6.2-19.5,13.13-27.31,21.88,6.77-9.66,16.73-16.87,27.31-21.88Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M202.33,355.06c-18.15,1.72-36.65,4.59-53.17,12.65,15.64-9.21,35.21-12.34,53.17-12.65Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M235.73,345.65c-2.18-3.38-1.55-9.95,2.2-11.4,3.53-1.36,7.61-.22,10.21,1.05,4.69,2.3,6.47,6.16-2.45,9.95C243.18,346.31,236.78,347.29,235.73,345.65Z",
                                                        fill: "#e8505b"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.g */.E.g, {
                                                initial: {
                                                    rotate: -0
                                                },
                                                animate: {
                                                    rotate: 360
                                                },
                                                transition: {
                                                    duration: 2,
                                                    ease: "linear",
                                                    repeat: Infinity
                                                },
                                                id: "strelka",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "376.38",
                                                        cy: "157.13",
                                                        r: "45.85",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "375",
                                                        cy: "156.18",
                                                        r: "63.99",
                                                        transform: "translate(-20.35 62.8) rotate(-9.32)",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "376.38",
                                                        cy: "157.13",
                                                        r: "45.85",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "376.38",
                                                        cy: "157.13",
                                                        r: "45.85",
                                                        fill: "#e8505b"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M378.83,156.52l40.9,43-43-40.91a1.5,1.5,0,1,1,2.12-2.12Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M377.77,94.25c0,17.94,1.07,45.15,1.5,63.32a1.5,1.5,0,0,1-3,.1c.43-18.31.65-45.37,1.5-63.42Z",
                                                        fill: "#fff"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                id: "circle2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M311,156.18c-.21,25.28,16.06,49.6,39.62,58.84C392.1,232,438.2,201,438,156.18c.2-44.82-45.89-75.79-87.36-58.83-23.55,9.23-39.83,33.54-39.62,58.83Zm0,0c-.36-25.41,15.92-49.74,39.38-59.42,42.44-17.91,89.53,13.36,89.6,59.42s-47.16,77.32-89.6,59.41c-23.46-9.68-39.74-34-39.38-59.41Z",
                                                    fill: "#263238"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.g */.E.g, {
                                                initial: {
                                                    x: 0,
                                                    rotateY: 180
                                                },
                                                animate: {
                                                    x: [
                                                        0,
                                                        -50,
                                                        50,
                                                        0
                                                    ],
                                                    rotate: 360
                                                },
                                                transition: {
                                                    duration: 4,
                                                    repeat: Infinity
                                                },
                                                id: "boul1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "629.77",
                                                        cy: "432.63",
                                                        r: "31.41",
                                                        transform: "translate(-116.36 268.1) rotate(-22.05)",
                                                        fill: "none"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                        cx: "629.77",
                                                        cy: "432.63",
                                                        r: "31.41",
                                                        transform: "translate(-116.36 268.1) rotate(-22.05)",
                                                        fill: "#455a64"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M660.66,424.71c-9.58,14.48-24.36,24.8-39.86,32.16-2.23,1.06-4.51,2-6.78,2.95,2.18-1.15,4.41-2.19,6.56-3.39,15.14-8,29.54-18.07,40.08-31.72Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M598.71,437.37c19.23-4.07,41.67-9.75,52.3-27.88h0c-9.18,18.79-33.11,25.35-52.3,27.88Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M624,431c-4.49-6.22-11-10.61-18-13.52-1-.46-2-.83-3-1.24,8.6,1.68,17,6.74,21,14.76Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M629.8,428.22c-3.75-7.75-10.66-13.34-18.4-16.81-1.09-.53-2.28-1-3.37-1.46,9.55,2.15,18.76,8.65,21.77,18.27Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M655.65,450.42c-1.74-4.28-3.3-8.71-6.2-12.38,3.95,2.71,5.82,7.75,6.2,12.38Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M650.68,456.06c-1.16-5.12-2.6-10.42-5.26-15,3.86,3.86,5.47,9.64,5.26,15Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M606.42,453.64c17.16-6.49,33.14-16.4,45.93-29.63,1.85-1.86,3.6-3.83,5.3-5.84-12.52,17-31.1,29.35-51.23,35.47Z",
                                                        fill: "#fff"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.g */.E.g, {
                                                initial: {
                                                    x: 0,
                                                    y: -100,
                                                    rotateY: 180
                                                },
                                                animate: {
                                                    x: [
                                                        0,
                                                        300,
                                                        -300,
                                                        -100,
                                                        150
                                                    ],
                                                    y: [
                                                        0,
                                                        200,
                                                        200,
                                                        -200,
                                                        150
                                                    ],
                                                    scale: [
                                                        0.4,
                                                        0.5,
                                                        0.7,
                                                        0.75,
                                                        0.5
                                                    ]
                                                },
                                                transition: {
                                                    duration: 3,
                                                    repeat: Infinity
                                                },
                                                id: "mouse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M429.53,433a1.66,1.66,0,0,1-.87-3.07c5.63-3.44,14.65-10.38,24.9-23.68,16.58-21.53,39.66-2.36,48.9,26.75Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M492.11,432.36c8.27-.35,16.77-.3,24.71,2.39,2.53.79,8.81,4.27,3.59,6.26-4.95,1.63-10.27,1.88-15.15,3.49a12.81,12.81,0,0,0-5.23,2.75c-8,10.15,30,12.41,35.49,12.83-9.37-.34-29.41-.91-36.32-7.27-3.8-4.56,1.71-8.17,5.76-9.26,4-1.24,8.18-1.74,12.2-2.57a10.94,10.94,0,0,0,4.14-1.46c1-1-1.37-2.21-2-2.73-4.46-2.57-9.69-3.29-14.77-3.87a109.16,109.16,0,0,0-12.4-.56Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M437.26,426.39s-5.19-18.84,9.1-21.44,15.37,14.51,12.34,20.58S437.26,426.39,437.26,426.39Z",
                                                        fill: "#263238"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M453.27,405c7.44,3.15,12.11,14.23,5.88,20.6a13.68,13.68,0,0,1-2.75,2.15c8.22-6.34,4.52-17.74-3.13-22.75Z",
                                                        fill: "#fff"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M446.81,414.12a95.1,95.1,0,0,1-2.35,9.94l-.55-.63a92,92,0,0,1,10.24-1,94.4,94.4,0,0,1-10.1,2l-.77.11a97.33,97.33,0,0,1,3.53-10.41Z",
                                                        fill: "#fff"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isAdded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Добавить объект недвижимости"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).title,
                                                children: [
                                                    "Тип сделки ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Add_module_default()).star,
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                radios: [
                                                    {
                                                        text: "Продажа",
                                                        value: "продажа"
                                                    },
                                                    {
                                                        text: "Аренда",
                                                        value: "аренда",
                                                        disabled: category === "участок"
                                                    }
                                                ],
                                                selected: type,
                                                onChange: function(v) {
                                                    setType(v);
                                                // setObjectsState({
                                                //   type: 'SET_FILTER',
                                                //   payload: {
                                                //     ...objectsState,
                                                //     type: v
                                                //   }
                                                // });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).title,
                                                children: [
                                                    "Объект сделки ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Add_module_default()).star,
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                radios: [
                                                    {
                                                        text: "Квартира",
                                                        value: "квартира"
                                                    },
                                                    {
                                                        text: "Комната",
                                                        value: "комната"
                                                    },
                                                    {
                                                        text: "Дом",
                                                        value: "дом"
                                                    },
                                                    {
                                                        text: "Участок",
                                                        value: "участок",
                                                        disabled: type === "аренда"
                                                    },
                                                    {
                                                        text: "Коммерция",
                                                        value: "коммерция"
                                                    }
                                                ],
                                                selected: category,
                                                onChange: function(v) {
                                                    setCategory(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                title: "Тип дома",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Доля",
                                                        value: "доля"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Дуплекс",
                                                        value: "дуплекс"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Отдельный дом",
                                                        value: "отдельный дом"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Таунхаус",
                                                        value: "таунхаус"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Часть дома",
                                                        value: "часть дома"
                                                    }
                                                ],
                                                selected: subCategory,
                                                visibility: [
                                                    "дом"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setSubCategory(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                title: "Тип участка",
                                                radios: [
                                                    {
                                                        text: "ИЖС",
                                                        value: "ижс"
                                                    },
                                                    {
                                                        text: "Садовый",
                                                        value: "садовый"
                                                    },
                                                    {
                                                        text: "Фермерский",
                                                        value: "фермерский"
                                                    }
                                                ],
                                                selected: lotType,
                                                visibility: [
                                                    "дом",
                                                    "участок"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setLotType(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).group,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        title: "Назначение",
                                                        options: [
                                                            {
                                                                type: "option",
                                                                text: "Автосервис",
                                                                value: "автосервис"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Гостиница",
                                                                value: "гостиница"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Готовый бизнес",
                                                                value: "готовый бизнес"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Земля комм.назначения",
                                                                value: "коммерческая земля"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Общепит",
                                                                value: "общепит"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Для офиса",
                                                                value: "офисное помещение"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Свободное назначение",
                                                                value: "псн"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Производство",
                                                                value: "производственное помещение"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Склад",
                                                                value: "склад"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Торговое помещение",
                                                                value: "торговое помещение"
                                                            }
                                                        ],
                                                        selected: commercialType,
                                                        visibility: [
                                                            "коммерция"
                                                        ].includes(category),
                                                        onChange: function(v) {
                                                            setCommercialType(v);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        title: "Тип здания",
                                                        options: [
                                                            {
                                                                type: "option",
                                                                text: "Бизнес-центр",
                                                                value: "бизнес-центр"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Встроенное помещение",
                                                                value: "встроенное помещение"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Отдельно стоящее здание",
                                                                value: "отдельно стоящее здание"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Складской комплекс",
                                                                value: "складской комплекс"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Торговый центр",
                                                                value: "Торговый центр"
                                                            }
                                                        ],
                                                        selected: commercialBuildingType,
                                                        visibility: [
                                                            "коммерция"
                                                        ].includes(category),
                                                        onChange: function(v) {
                                                            setCommercialBuildingType(v);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        title: "Ремонт",
                                                        options: [
                                                            {
                                                                type: "option",
                                                                text: "Дизайнерский",
                                                                value: "дизайнерский"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Евроремонт",
                                                                value: "евро"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Требует ремонта",
                                                                value: "требует ремонта"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Хороший",
                                                                value: "хороший"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Частичный ремонт",
                                                                value: "частичный ремонт"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Черновая отделка",
                                                                value: "черновая отделка"
                                                            }
                                                        ],
                                                        selected: renovation,
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "дом",
                                                            "коммерция"
                                                        ].includes(category),
                                                        onChange: function(v) {
                                                            setRenovation(v);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).title,
                                                children: [
                                                    "Местоположение ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Add_module_default()).star,
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                id: "suggest",
                                                inputs: [
                                                    {
                                                        placeholder: "Введите адрес "
                                                    }
                                                ],
                                                ref: addressId
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Add_module_default()).mapContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* YMaps */.Yy, {
                                                    query: {
                                                        apikey: "30499cc5-6350-4442-960c-6c0de5a8ad59",
                                                        suggest_apikey: "68e91b85-a04e-472b-a7c8-15bb786c3985"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Map */.D5, {
                                                        className: (Add_module_default()).mapContainerMap,
                                                        onLoad: function(ymaps) {
                                                            return loadSuggest(ymaps);
                                                        },
                                                        controls: [],
                                                        defaultState: {
                                                            center: (locationState === null || locationState === void 0 ? void 0 : (ref = locationState.coordinates) === null || ref === void 0 ? void 0 : ref.length) ? locationState.coordinates : [
                                                                55.75,
                                                                37.57
                                                            ],
                                                            zoom: 12
                                                        },
                                                        modules: [
                                                            "SuggestView",
                                                            "geocode"
                                                        ],
                                                        defaultOptions: {
                                                            maxZoom: 20,
                                                            autoFitToViewport: "always",
                                                            yandexMapDisablePoiInteractivity: true,
                                                            suppressObsoleteBrowserNotifier: true,
                                                            suppressMapOpenBlock: true
                                                        },
                                                        instanceRef: function(ref) {
                                                            if (ref) mapEl.current = ref;
                                                        },
                                                        children: rawPoints && rawPoints.map(function(value, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_yandex_maps_esm/* Placemark */.ah, {
                                                                properties: {
                                                                    hintContent: value.address,
                                                                    iconContent: value.address
                                                                },
                                                                options: {
                                                                    preset: "islands#blackStretchyIcon"
                                                                },
                                                                geometry: value.point
                                                            }, index);
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).title,
                                                children: [
                                                    "Параметры ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Add_module_default()).star,
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                title: "Стоимость, ₽",
                                                inputs: [
                                                    {
                                                        mask: "money",
                                                        value: price,
                                                        max: 9999999999
                                                    }
                                                ],
                                                onChange: function(v) {
                                                    setPrice(v[0]);
                                                },
                                                suffix: "₽",
                                                ref: priceId
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                title: "Комнат",
                                                radios: [
                                                    {
                                                        text: "Студия",
                                                        value: "студия"
                                                    },
                                                    {
                                                        text: "1",
                                                        value: "1"
                                                    },
                                                    {
                                                        text: "2",
                                                        value: "2"
                                                    },
                                                    {
                                                        text: "3",
                                                        value: "3"
                                                    },
                                                    {
                                                        text: "4",
                                                        value: "4"
                                                    },
                                                    {
                                                        text: "5+",
                                                        value: "5"
                                                    }, 
                                                ],
                                                visibility: [
                                                    "квартира"
                                                ].includes(category),
                                                selected: studio ? "студия" : rooms,
                                                onChange: function(v) {
                                                    if (v == "студия") {
                                                        setStudio(1);
                                                        setRooms(0);
                                                    } else {
                                                        setStudio(0);
                                                        setRooms(v);
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).group,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Общая площадь, м\xb2",
                                                        inputs: [
                                                            {
                                                                mask: "number",
                                                                value: square,
                                                                max: 999999
                                                            }
                                                        ],
                                                        suffix: [
                                                            "участок"
                                                        ].includes(category) ? "сот" : "м\xb2",
                                                        onChange: function(v) {
                                                            setSquare(v[0]);
                                                        },
                                                        ref: squareId
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Жилая площадь, м\xb2",
                                                        inputs: [
                                                            {
                                                                mask: "number",
                                                                value: squareLiving,
                                                                max: 999999
                                                            }
                                                        ],
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "дом"
                                                        ].includes(category),
                                                        suffix: "м\xb2",
                                                        onChange: function(v) {
                                                            setSquareLiving(v[0]);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Площадь кухни, м\xb2",
                                                        inputs: [
                                                            {
                                                                mask: "number",
                                                                value: squareKitchen,
                                                                max: 999999
                                                            }
                                                        ],
                                                        visibility: [
                                                            "квартира",
                                                            "комната"
                                                        ].includes(category),
                                                        suffix: "м\xb2",
                                                        onChange: function(v) {
                                                            setSquareKitchen(v[0]);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Площадь участка",
                                                        inputs: [
                                                            {
                                                                placeholder: "Площадь",
                                                                mask: "number",
                                                                value: squareArea,
                                                                max: 999999
                                                            }
                                                        ],
                                                        visibility: [
                                                            "дом",
                                                            "участок",
                                                            "коммерция"
                                                        ].includes(category),
                                                        suffix: "сот",
                                                        onChange: function(v) {
                                                            setSquareArea(v[0]);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).group,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Этаж",
                                                        inputs: [
                                                            {
                                                                mask: "number",
                                                                value: floor,
                                                                max: 999
                                                            }
                                                        ],
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "коммерция"
                                                        ].includes(category),
                                                        suffix: "эт",
                                                        onChange: function(v) {
                                                            setFloor(v[0]);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Этажность",
                                                        inputs: [
                                                            {
                                                                mask: "number",
                                                                value: floors,
                                                                max: 999999
                                                            }
                                                        ],
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "дом",
                                                            "коммерция"
                                                        ].includes(category),
                                                        suffix: "эт",
                                                        onChange: function(v) {
                                                            setFloors(v[0]);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        title: "Высота потолка, м",
                                                        inputs: [
                                                            {
                                                                mask: "number",
                                                                value: ceiling,
                                                                max: 9
                                                            }
                                                        ],
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "дом"
                                                        ].includes(category),
                                                        suffix: "м",
                                                        onChange: function(v) {
                                                            setCeiling(v[0]);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).group,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        title: "Фонд здания",
                                                        options: [
                                                            {
                                                                type: "option",
                                                                text: "Коттедж",
                                                                value: "коттедж"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Новостройка",
                                                                value: "новостройка"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Современный",
                                                                value: "современный"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Сталинский",
                                                                value: "сталинский"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Старый фонд",
                                                                value: "старый фонд"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Хрущевка",
                                                                value: "хрущевка"
                                                            }
                                                        ],
                                                        selected: stock,
                                                        visibility: [
                                                            "квартира",
                                                            "комната"
                                                        ].includes(category),
                                                        onChange: function(v) {
                                                            setStock(v);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        title: "Материал стен дома",
                                                        options: [
                                                            {
                                                                type: "option",
                                                                text: "Блочный",
                                                                value: "блочный"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Кирпично-монолитный",
                                                                value: "кирпично-монолитный"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Кирпичный",
                                                                value: "кирпичный"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Монолит",
                                                                value: "монолит"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Панельный",
                                                                value: "панельный"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Деревянный",
                                                                value: "деревянный"
                                                            }
                                                        ],
                                                        selected: buildingType,
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "дом"
                                                        ].includes(category),
                                                        onChange: function(v) {
                                                            setBuildingType(v);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                        title: "Ремонт",
                                                        options: [
                                                            {
                                                                type: "option",
                                                                text: "Евроремонт",
                                                                value: "евроремонт"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Косметический",
                                                                value: "косметический"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Дизайнерский",
                                                                value: "дизайнерский"
                                                            },
                                                            {
                                                                type: "option",
                                                                text: "Требует ремонта",
                                                                value: "требует ремонта"
                                                            }
                                                        ],
                                                        selected: renovation,
                                                        visibility: [
                                                            "квартира",
                                                            "комната",
                                                            "дом"
                                                        ].includes(category),
                                                        onChange: function(v) {
                                                            setRenovation(v);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                title: "Тип участка",
                                                radios: [
                                                    {
                                                        text: "ИЖС",
                                                        value: "ижс"
                                                    },
                                                    {
                                                        text: "Садовый",
                                                        value: "садовый"
                                                    },
                                                    {
                                                        text: "Фермерский",
                                                        value: "фермерский"
                                                    }
                                                ],
                                                selected: lotType,
                                                visibility: [
                                                    "дом",
                                                    "участок"
                                                ].includes(category),
                                                onChange: function(v) {
                                                    setLotType(v);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).title,
                                                children: [
                                                    "Описание объекта ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Add_module_default()).star,
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* default */.Z, {
                                                placeholder: "Поле для вашего красивого рассказа о данном объекте :)",
                                                inputs: [
                                                    {
                                                        value: description
                                                    }
                                                ],
                                                autoHeight: true,
                                                isWrappedStyle: true,
                                                onChange: function(v) {
                                                    return setDescription(v);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Add_module_default()).title,
                                                children: [
                                                    "Фото объекта ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (Add_module_default()).star,
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Вы можете загрузить до 30 фотографий. Качественные фотографии повышают интерес потенциальных покупателей и арендаторов в несколько раз."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MyDropzone, {
                                                images: images
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: [
                                            "Контактная информация ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (Add_module_default()).star,
                                                children: "*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                title: "",
                                                inputs: [
                                                    {
                                                        placeholder: "Контактное лицо",
                                                        value: contactName
                                                    }
                                                ],
                                                onChange: function(v) {
                                                    setContactName(v[0]);
                                                },
                                                ref: contactsNameId
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                title: "",
                                                inputs: [
                                                    {
                                                        placeholder: "Телефон",
                                                        value: contactPhone,
                                                        mask: "phone",
                                                        type: "tel"
                                                    }
                                                ],
                                                onChange: function(v) {
                                                    setContactPhone(v[0]);
                                                    checkContactPhone(v[0]);
                                                },
                                                ref: contactPhoneId
                                            }),
                                            showInvite && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    textAlign: "left",
                                                    opacity: 0.8,
                                                    fontSize: 14,
                                                    margin: "18px 0"
                                                },
                                                children: [
                                                    "Номер нам не известен - пожалуйста - ",
                                                    " ",
                                                    "перейдите в ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://t.me/baza_estateBot?start=hello",
                                                        target: "_blank",
                                                        children: "TeleGram бота"
                                                    }),
                                                    " ",
                                                    "и подтвердите номер.",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Бот используется для подтверждения номера, а также уведомления о модерации или продления объявления",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "После подтверждения ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function() {
                                                            return checkContactPhone(contactPhone, true);
                                                        },
                                                        children: "нажмите сюда"
                                                    })
                                                ]
                                            }),
                                            showCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                title: showCode,
                                                inputs: [
                                                    {
                                                        placeholder: "Код",
                                                        value: authCode,
                                                        mask: 9999
                                                    }
                                                ],
                                                onChange: function(v) {
                                                    setAuthCode(v[0]);
                                                    checkCode(v[0]);
                                                },
                                                ref: codeId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            textAlign: "left",
                                            opacity: 0.8,
                                            fontSize: 12,
                                            margin: "18px 0"
                                        },
                                        children: [
                                            "Вы соглашаетесь с",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/faq/policy",
                                                target: "_blank",
                                                children: "политикой конфиденциальности"
                                            }),
                                            " ",
                                            "при отправке данной формы к нам в работу"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Add_module_default()).subBlock,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            className: (Add_module_default()).addButton,
                                            color: "red",
                                            disabled: addButton,
                                            onClick: handleAddClick,
                                            loading: isLoading,
                                            children: "Добавить объект"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                seo: [
                    "Продайте или сдайте недвижимость в ",
                    locationState.case,
                    " на baza.estate"
                ].join("")
            })
        ]
    });
};
/* harmony default export */ var add = (AddPage);


/***/ }),

/***/ 4914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rd":"Radio_rd__0BfzT","inline":"Radio_inline___zsgd","rdTitle":"Radio_rdTitle__btW0q","rdContent":"Radio_rdContent__fCwBL","rdRadio":"Radio_rdRadio__IL3oA","disabled":"Radio_disabled___WB5e","active":"Radio_active__OTBHA"};

/***/ }),

/***/ 1319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"txt":"Textarea_txt__h9LCE","txtTitle":"Textarea_txtTitle__NdQd9","txtContent":"Textarea_txtContent__t4AHN","full":"Textarea_full__ldXF7","error":"Textarea_error__z_vDn"};

/***/ }),

/***/ 8803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"Add_content__ZocTw","subBlock":"Add_subBlock__nX_oP","title":"Add_title__Yqvl4","group":"Add_group__2NMkd","star":"Add_star__GYBV8","mapContainer":"Add_mapContainer__UPmic","mapContainerMap":"Add_mapContainerMap__NZnRt","addButton":"Add_addButton__0ArSV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,5990,798,3193,360,9774,2888,179], function() { return __webpack_exec__(4664); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);